
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
    isParticipantModerator
} from '../../base/participants';
import { getIsParticipantAudioMuted, getIsParticipantVideoMuted } from '../../base/tracks';
import { ACTION_TRIGGER } from '../constants';
import { getParticipantAudioMediaState, getParticipantVideoMediaState } from '../functions';

import { ParticipantItem } from './ParticipantItem';

type Props = {

    /**
     * Is this item highlighted.
     */
    isHighlighted: boolean,

    /**
     * Callback used to open a confirmation dialog for audio muting.
     */
    muteAudio: Function,

    /**
     * Callback for the activation of this item's context menu.
     */
    onContextMenu: Function,

    /**
     * Callback for the mouse leaving this item.
     */
    onLeave: Function,

    /**
     * Participant reference.
     */
    participant: Object
};

export const MeetingParticipantItem = ({
    isHighlighted,
    onContextMenu,
    onLeave,
    raiseHandP,
    participantList,
    muteAudio,
    participant,
    index,
    hideOptions
}: Props) => {
    const { t } = useTranslation();
    const isAudioMuted = useSelector(getIsParticipantAudioMuted(participant));
    const isVideoMuted = useSelector(getIsParticipantVideoMuted(participant));
    const audioMediaState = useSelector(getParticipantAudioMediaState(participant, isAudioMuted));
    const videoMediaState = useSelector(getParticipantVideoMediaState(participant, isVideoMuted));

    return (
        <ParticipantItem
            actionsTrigger = { ACTION_TRIGGER.HOVER }
            ariaLabel = { t('toolbar.moreOptions') }
            audioMediaState = { audioMediaState }
            hideOptions = { hideOptions }
            index = { index }
            isHighlighted = { isHighlighted }
            isModerator = { isParticipantModerator(participant) }
            muteAudio = { muteAudio }
            onContextMenu = { onContextMenu }
            onLeave = { onLeave }
            participant = { participant }
            participantList = { participantList }
            raiseHandP = { raiseHandP }
            videoMuteState = { videoMediaState }>
            {/* {!isInBreakoutRoom && <ParticipantQuickAction
                isAudioMuted={isAudioMuted}
                muteAudio={muteAudio}
                participant={participant}
                participantID={_participantID} />} */}
            {/* <ParticipantActionEllipsis
                aria-label={t('MeetingParticipantItem.ParticipantActionEllipsis.options')}
                onClick={onContextMenu} /> */}
        </ParticipantItem>
    );
};
